import AccountList from "../AccountList";
import Button from "../../Input/Button";
import * as Icon from "react-bootstrap-icons";

import Context from "../../../../context";
import { useContext, useState } from "react";
import {API_URL} from "../../../data/constants";
import { useHistory } from "react-router";
import FormField from "../../Input/FormField";
import { useFormik } from "formik";
import axios from "axios";

export default function ManageAccountListPage({ 
                                                  isLoading,
                                                  setIsLoading,
                                                  currentPage,
                                                  perPage,
                                                  numItems,
                                                  paginate,
                                                  setPerPage,
                                              }) {
    const { contextState, setContextState } = useContext(Context);
    const [searchError, setSearchError] = useState();
    const [searchMessage, setSearchMessage] = useState();

    const history = useHistory();
    
    function calcStatus(status) {
        let count = 0;
        contextState.accounts.forEach((current) => {
          if (current.status === status) count++;
        });
        return count;
    }

    function searchValidate(values) {
        const errors = {};
        if (!values.customerNumber) {
            errors.customerNumber = "Required";
        } else if (!/^\d+$/.test(values.customerNumber)) {
            errors.customerNumber = "Invalid Customer Number (Only Numerical values)";
        }
        return errors;
    }
    
    const searchForm = useFormik({
        initialValues: {
            customerNumber: "",
        },
        validate: searchValidate,
        onSubmit: (values) => {
            setIsLoading(true);
            setSearchError();
            setSearchMessage();
            
            axios
                .post(
                    API_URL + "/Accounts/Search",
                    {
                        userName: localStorage.getItem("username"),
                        customerNumber: values.customerNumber
                    },
                    { headers: { Authorization: localStorage.getItem("accessToken") } }
                )
                .then((res) => {
                    if (res.data.accounts.length === 1) {
                        setContextState({
                            ...contextState,
                            currentAccount: res.data.accounts[0],
                        });
                        history.push(`account/${res.data.accounts[0].customerNumber}/detail`);
                    }
                    
                    setIsLoading(false);

                    if (res.data.accounts.length === 0) {
                        setSearchError('No Results Found');
                    }
                })
                .catch((err) => console.error(err));
        },
    });
  
  return (
    <div className="manage-accounts-container">
      <h1 className="manage-accounts-welcome">Welcome Back</h1>
      <div className="manage-accounts-buttons">
        <div className="add-or-link-container">
          <Button
            className="btn-fluid btn--green btn--bordered"
            text="Add or Link Account"
            onClick={() => {
              setContextState({ ...contextState, manageActivePage: "add" });
            }}
          />
        </div>
        <div className="manage-accounts-button-container">
          <Button disabled={true}
            className="btn-fluid btn--blue btn--bordered"
            icon={<Icon.FilePdf className="header-btn-icon" />}
            onClick={() => {
              setContextState({
                ...contextState,
                manageActivePage: "download",
              });
            }}
          />
          <Button
            className="btn-fluid btn--blue btn--bordered"
            text="Setup Autopay"
            onClick={() => {
              setContextState({ ...contextState, manageActivePage: "autopay" });
            }}
          />
        </div>
      </div>
      <div className="manage-accounts-info-block">
        <h2 className="info-block-header">Accounts</h2>
        <div className="info-accounts-container">
          <span className="info-container">
            <p className="display-4">
              {calcStatus("PastDue") === 0
                ? calcStatus("ShutOff")
                : calcStatus("PastDue")}{" "}
              Past Due
            </p>
          </span>
          <span className="info-container">
            <p className="display-4">{calcStatus("Due") + calcStatus("DueSoon")} Due</p>
          </span>
          <span className="info-container">
            <p className="display-4">{calcStatus("Paid")} Paid</p>
          </span>
        </div>
        <div className="search-container form-row">
          <form onSubmit={searchForm.handleSubmit}>
              <div className="search-child">
                  <FormField
                      form={searchForm}
                      field="customerNumber"
                      name="Customer Number"
                      type="text"
                  />
                  {searchError && <p className="text-danger">{searchError}</p>}
                  {searchMessage && <p>{searchMessage}</p>}
              </div>
              <div className="search-child">
                  <Button
                      type="submit"
                      text="Search"
                      className="btn btn--green btn--bordered search-button"
                      disabled={!(searchForm.dirty && searchForm.isValid)}
                  />
              </div>
          </form>
        </div>
      </div>
      <AccountList 
          isLoading={isLoading}
          perPage={perPage}
          setPerPage={setPerPage}
          currentPage={currentPage}
          numItems={numItems}
          paginate={paginate}/>
    </div>
  );
}
